export const sleep = (secs: number) => new Promise((r) => setTimeout(r, secs * 1e3));

export const randomInt = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};

export const capitalize = (str: string) => str[0].toUpperCase() + str.slice(1);

export const getIdDisplayValue = (id: number | undefined | null): string => {
    return id === null ? '' : id?.toString() ?? 'N/A';
};

type OpenPopupOptions = {
    width: number;
    height: number;
};

export const openPopup = (url: string | URL, { width, height }: OpenPopupOptions) => {
    const popup = window.open(
        url,
        // Allow multiple popups of different URLs to be open at once.
        `${url}-popup-window`,
        `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,popup=yes,width=${width}px,height=${height}px,top=200px,left=200px`
    );

    if (!popup) {
        throw new Error('Popup could not be opened! Ensure the popup is being opened as the result of a user action.');
    }

    // Because resizable=no doesn't work in all browsers (including Chrome).
    const handleResize = () => {
        popup.resizeTo(width, height);
    };

    // Clean up listeners when the popup is closed.
    const handleClose = () => {
        popup.removeEventListener('resize', handleResize);
        popup.removeEventListener('beforeunload', handleClose);
    };

    popup.addEventListener('resize', handleResize);
    popup.addEventListener('beforeunload', handleClose);

    return popup;
};

export const getDeviceType = (userAgent: string): 'mobile' | 'desktop' => {
    const matches = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /iOS/i,
        /BlackBerry/i,
        /Windows Phone/i,
        /Mobile/i,
    ];
    return matches.some((regex) => userAgent.match(regex)) ? 'mobile' : 'desktop';
};
